export const environment = {
  production: false,
  //apiUrl: 'https://boxx-crm-staging.virket.net',
  apiUrl: 'https://panel.myboxx.app',
  instanceName: 'boxx-crm',
  //appThemeKey: 'VmVudGFzQ2xpY2s'  //Prod
  appThemeKey: 'VmVudGFzQ2xpY2s', //Staging
  brand_id: 27,
};